<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
                @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" icon="el-icon-download" size="small" plain
                        @click.stop="downloadExcel">下载Excel</el-button>
                    <!-- 下载更换提醒Excel -->
                    <el-button type="success" icon="el-icon-download" size="small" plain
                        @click.stop="downloadReplacementReminderExcel">下载更换提醒Excel</el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="success" icon="el-icon-check" size="small" plain
                        v-if="scope.row.status == 'WAIT_AUDIT'" @click.stop="pass(scope.row.id)">通过</el-button>
                    <el-button type="danger" icon="el-icon-close" size="small" plain
                        v-if="scope.row.status == 'WAIT_AUDIT'" @click.stop="refuse(scope.row.id)">拒绝</el-button>
                    <el-button type="danger" icon="el-icon-error" size="small" plain v-if="scope.row.status == 'DONE'"
                        @click.stop="refunded(scope.row.id)">退回</el-button>
                    <el-button type="success" icon="el-icon-view" size="small" plain
                        @click.stop="toView(scope.row.id, scope.$index)">查看</el-button>
                        <el-button v-if="scope.row.isEvaluate" type="info" icon="el-icon-view" size="small" plain
                        @click.stop="evaluateInfoView(scope.row.id, scope.$index)">评价</el-button>
                    <el-button type="primary" icon="el-icon-check" size="small" plain @click.stop="openPay(scope.row)"
                        v-if="scope.row.status == 'WAIT_PAY'">立即付款</el-button>
                </template>
                <template slot-scope="scope" slot="imageUrl">
                    <viewer :images="formmaterImage(scope.row.imageUrl)">
                        <img v-for="src in formmaterImage(scope.row.imageUrl)" :src="src" :key="src" width="20" />
                    </viewer>
                </template>
                <template slot-scope="scope" slot="status">
                    <el-tag v-for="obj of preFilterStatus" :key="obj.value" v-if="obj.value == scope.row.status">{{
                        obj.label }}</el-tag>
                </template>
            </avue-crud>
            <template>
                <el-dialog :visible.sync="rechargeDialog" title="充值" center width="1000px">
                    <div class="remittance"
                        style="font-size: 14px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px">
                        <div class="recharge">
                            <span
                                style="width:130px;text-align:left;">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <el-input type="number" placeholder="请输入充值金额" v-model="rechargeMoney"
                                style="width:215px"></el-input>
                        </div>
                        <div style="display: flex;justify-content:flex-start;">
                            <span style="width:130px;text-align:left;">支付方式:</span>
                            <div>
                                <el-radio v-model="payRadio" label="OFFLINE_REMIT"
                                    @change="rechargeWayOFFLINE_REMIT">线下汇款</el-radio>
                                <el-radio v-model="payRadio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio>
                            </div>
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span
                                style="width:130px;text-align:left;">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <el-input type="text" placeholder="请输入汇款账户名称" v-model="remittanceAccountName"
                                style="width:215px"></el-input>
                            <i
                                style="font-style:normal;display: inline;font-size: 12px;color:red">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span
                                style="width:130px;text-align:left;">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <el-input type="text" placeholder="请输入汇款账户" v-model="remittanceAccount"
                                style="width:215px"></el-input>
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'"
                            style="display: flex;justify-content:flex-start;">
                            <span style="width:130px;text-align:left;">汇款银行:</span>
                            <div>
                                <el-select placeholder="请输入汇款银行" v-model="currBank" style="width:215px">
                                    <el-option v-for="item in remittanceBank" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'" style=" margin-bottom:40px ">
                            <span style="width:130px;text-align:left; ">凭证:</span>
                            <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                                :file-list="fileList1" :http-request="fnUploadremittanceImgs" :show-file-list="false">
                                <div v-if="'' != remittanceImgs" class="el-upload el-upload--picture-img">
                                    <img v-for="remittanceImg of remittanceImgs" :key="remittanceImg.value"
                                        :src="remittanceImg" style="width: 200px;" />
                                </div>
                                <div v-else class="el-upload el-upload--car-two">
                                    <i class="el-icon-plus"></i>
                                </div>
                                <div class="el-upload__tip">
                                    请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb
                                </div>
                            </el-upload>
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span style="width:130px;text-align:left;">账户名称:</span>
                            成都聚家科技有限公司
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span style="width:130px;text-align:left;">账户号码:</span>
                            4402209109100103208
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span style="width:130px;text-align:left;">开户银行:</span>
                            中国工商银行股份有限公司成都天顺路支行
                        </div>
                        <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
                            <span style="width:130px;text-align:left;">汇款提示:</span>
                            请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
                        </div>
                    </div>
                    <div class="remittanceButton">
                        <el-button round size="mini"
                            @click="balancePayment">&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
                        <el-button round type="danger" size="mini"
                            @click="rechargeDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
                    </div>
                </el-dialog>
            </template>

            <template>
                <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
                    <vue-qr :text="config.value" :size="200"></vue-qr>
                    <el-row>二维码只会展示2分钟，请及时支付</el-row>
                    <el-button @click="closeQRCodeDialog">关闭</el-button>
                </el-dialog>
            </template>
            <el-dialog title="选择付款方式" center :visible.sync="dialogBalancePay" width="50%">
                <div style="display: flex;justify-content: space-around;">
                    <el-radio v-if="!noMoney" v-model="balancePayRadio" label="YE">账户余额({{ getBalance + "元"
                        }})</el-radio>
                    <el-radio v-if="noMoney" v-model="balancePayRadio" label="YE">
                        账户余额(
                        <span style="color:red">
                            余额不足
                            <a href="#" style="color:#409EFF;margin-left:3px;text-decoration: underline;"
                                @click="toPayMoney">去充值</a> </span>)
                    </el-radio>
                    <el-radio v-model="balancePayRadio" label="WX">微信支付</el-radio>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogBalancePay = false">取 消</el-button>
                    <el-button type="primary" @click="listPay">确认支付</el-button>
                </span>
            </el-dialog>
            <!-- downloadReplacementReminderExcel弹窗，输入day（今天往后day）的日期打印 -->
            <el-dialog title="下载更换提醒Excel" :visible.sync="downloadReplacementReminderExcelDialog" width="30%">
                <el-form :model="downloadReplacementReminderExcelForm" label-width="150px">
                    <el-form-item label="更换提醒时间">
                        <el-input v-model="downloadReplacementReminderExcelForm.day" placeholder="请输入天数"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="downloadReplacementReminderExcelDialog = false">取 消</el-button>
                    <el-button type="primary" @click="downloadReplacementReminderExcelSubmit">确 定</el-button>
                </span>
            </el-dialog>
        </basic-container>
    </div>
</template>

<script>
import { baseUrl } from "@/config/env";
import { mapGetters } from "vuex";
import { preFilterWaterOption } from "@/const/salesCloud/preFilterWaterOption";
import {
    findpreFilterWater,
    refused,
    pass,
    balancePay,
    serveOrderPay,
    findpreFilterDownloadExcel,
    refund,
    downloadExcelPureWaterGoods,
    downloadReplacementReminderExcel,
} from "@/api/salesCloud/preFilter";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findUserId } from "@/api/salesCloud/company";
import { resolveUrlPath } from "@/util/util";
import { parseParam } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import VueQr from "vue-qr";

export default {
    name: "preFilter",
    components: {
        VueQr,
    },
    data() {
        return {
            tableOption: preFilterWaterOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            tabelObj: {},
            downloadData: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
            detailVisible: false,
            detailData: [],
            selectRedPacket: {},
            detailSearch: {},
            detailPage: {
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            //余额支付
            balancePayRadio: "YE",
            serviceCategorys: [],
            serviceCategory: {},
            joinsWorkServiceItems: [],
            workOrderStatus: DIC.WORK_ORDER_STATUS,
            QRCodeDialog: false,
            config: {},
            noMoney: true,
            getBalance: 0,
            evaluateDialog: false,
            dialogBalancePay: false,
            rechargeDialog: false,
            downloadReplacementReminderExcelDialog: false,
            downloadReplacementReminderExcelForm: {
                day: "",
            },
            rechargeMoney: "",
            payRadio: "OFFLINE_REMIT",
            remittanceAccountName: "",
            remittanceAccount: "",
            currBank: "",
            remittanceBank: DIC.BANK_LIST,
            fileList1: [],
            remittanceImgs: [],
            brands: [],
            brand: {},
            classifies: [],
            classify: {},
            departments: [],
            department: {},
            secondClassifies: [],
            secondClassify: {},
            goodsList: [],
            goods: {},
            preFilterStatus: DIC.PRE_FILTER_STATUS,
        };
    },
    created() {
        this.handleList();
    },
    watch: {},
    mounted() { },
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        openPay(row) {
            console.log(row, 3333);
            this.payRow = row;
            findBalance().then((res) => {
                let data = JSON.parse(res.data);
                console.log(data, 2222);
                this.getBalance = data.rows[0].balance;
                let wxPay = row.promotionCost;
                // let wxPay = 1111111;
                console.log(wxPay, this.getBalance);
                console.log(data, 11111);
                this.noMoney = wxPay > this.getBalance;
                this.dialogBalancePay = true;
            });
        },
        getBalanceMoney() {
            findBalance().then((res) => {
                let data = JSON.parse(res.data);
                this.getBalance = data.rows[0].balance;
                console.log(this.getBalance);
            });
        },
        listPay() {
            if (this.balancePayRadio == "WX") {
                this.immediatePayment(this.payRow.id);
            } else {
                balancePay(this.payRow.id).then((res) => {
                    console.log(res);
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "支付成功",
                            type: "success",
                        });
                        setTimeout(() => {
                            this.handleList();
                        }, 2000);
                        this.dialogBalancePay = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: "余额不足",
                            type: "error",
                        });
                        this.handleList();
                        this.dialogBalancePay = false;
                    }
                });
            }
        },
        destroyThisPay() {
            this.QRCodeDialog = false;
            this.rechargeDialog = false;
            this.payMoneyDialog = false;
            this.dialogBalancePay = false;
        },
        clean() {
            this.describeImgs = [];
            this.remittanceImgs = [];
            this.rechargeMoney = "";
            this.paymentTask = {};
            this.remittanceAccountName = "";
            this.remittanceAccount = "";
            this.currBank = "";
        },
        balancePayment() {
            let params = {};
            params.money = this.rechargeMoney;
            params.rechargeType = "BALANCE";
            params.payType = this.payRadio;
            params.openingUser = this.remittanceAccountName;
            params.bankNumber = this.remittanceAccount;
            params.bankName = this.currBank;
            params.url = this.remittanceImgs + "";
            if (params.payType == "OFFLINE_REMIT") {
                if (
                    params.money &&
                    params.openingUser &&
                    params.bankNumber &&
                    params.bankName &&
                    params.url
                ) {
                    addBalance(params).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message:
                                    "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                                type: "success",
                            });
                            this.rechargeDialog = false;
                            this.payMoneyDialog = false;
                            this.dialogBalancePay = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: "请完善输入信息",
                        type: "error",
                    });
                }
            } else {
                addBalance(params).then((response) => {
                    this.tableLoading = false;
                    if (response.code == "200") {
                        let data = response.data;
                        let count = 0;
                        wxNativePayQuery(data.outTradeNo).then((res) => {
                            if (res.code == "200") {
                                if (res.data == "SUCCESS") {
                                    let _this = this;
                                    setTimeout(function () {
                                        _this.QRCodeDialog = false;
                                        _this.$message({
                                            showClose: true,
                                            message: "充值成功",
                                            type: "success",
                                        });
                                        _this.handleList();
                                        _this.payMoneyDialog = false;
                                        _this.rechargeDialog = false;
                                        _this.dialogBalancePay = false;
                                    }, 1000);
                                } else {
                                    count++;
                                    if (count < 3) {
                                        wxNativePayQuery(data.outTradeNo).then((res) => {
                                            if (res.code == "200") {
                                                if (res.data == "SUCCESS") {
                                                    let _this = this;
                                                    setTimeout(function () {
                                                        _this.QRCodeDialog = false;
                                                        _this.$message({
                                                            showClose: true,
                                                            message: "充值成功",
                                                            type: "success",
                                                        });
                                                        _this.handleList();
                                                        _this.payMoneyDialog = false;
                                                        _this.rechargeDialog = false;
                                                        _this.dialogBalancePay = false;
                                                    }, 1000);
                                                } else {
                                                    this.QRCodeDialog = false;
                                                    this.rechargeDialog = false;
                                                    this.dialogBalancePay = false;
                                                    this.$message({
                                                        showClose: true,
                                                        message: "支付超时",
                                                        type: "error",
                                                    });
                                                }
                                            } else {
                                                this.QRCodeDialog = false;
                                                this.rechargeDialog = false;
                                                this.dialogBalancePay = false;
                                                this.$message({
                                                    showClose: true,
                                                    message: "支付超时",
                                                    type: "error",
                                                });
                                            }
                                        });
                                    }
                                }
                                //this.handleList();
                            } else {
                                this.QRCodeDialog = false;
                                this.$message({
                                    showClose: true,
                                    message: "支付失败",
                                    type: "error",
                                });
                                this.handleList();
                            }
                        });
                        let start = new Date().getTime();
                        while (true) if (new Date().getTime() - start > 1) break;
                        this.config.value = "";
                        this.config.value = data.codeUrl;
                        this.QRCodeDialog = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: "支付失败",
                            type: "error",
                        });
                        //???下面的感觉没用
                        // this.$refs.crud.rowAdd();
                        return;
                    }
                    // let data = JSON.parse(res.data);
                });
            }
        },
        rechargeWayBALANCE() {
            this.paymentTask.rechargeWay = "BALANCE";
        },
        rechargeWayWX_PAY() {
            this.paymentTask.rechargeWay = "WX_PAY";
        },
        rechargeWayOFFLINE_REMIT() {
            this.paymentTask.rechargeWay = "OFFLINE_REMIT";
        },
        toPayMoney() {
            console.log("充值");
            this.clean();
            this.rechargeDialog = true;
        },
        async fnUploadremittanceImgs(option) {
            this.tableLoading = true;
            getAliyunPublicToken().then((res) => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then((results) => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file);
                        }
                        this.fileList1 = files;
                        let array = results.res.requestUrls[0].split("?");
                        this.remittanceImgs.push(array[0]);
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    // console.log("url："+ row[i].url)
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        closeQRCodeDialog() {
            this.QRCodeDialog = false;
            this.handleList();
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            (params.page = this.page.currentPage), (params.size = pageSize);
            params.qrType = 'PURE_WATER';
            findpreFilterWater(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            params.qrType = 'PURE_WATER';
            findpreFilterWater(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            console.log(params);
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            console.log(params, 1111);
            // 确认 params.startTime 和 params.endTime 是有效的 Date 对象
            if (params.startTime instanceof Date) {
                console.log(params.startTime, 1111);
                params.startTime = params.startTime.getTime();
            }
            if (params.endTime instanceof Date) {
                params.endTime = params.endTime.getTime();
            }

            this.downloadData = params;
            params.qrType = 'PURE_WATER';
            findpreFilterWater(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size,
                };
                this.tableLoading = false;
            });
        },

        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            params.qrType = 'PURE_WATER';
            findpreFilterWater(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            if (
                null != row.startDate &&
                undefined != row.startDate &&
                null != row.endDate &&
                undefined != row.endDate
            ) {
                let time = new Array();
                time.push(row.startDate);
                time.push(row.endDate);
                row.startDate_endDate = time;
            }
            this.$refs.crud.rowEdit(row, index);
        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            params.qrType = 'PURE_WATER';
            findpreFilterWater(params).then((res) => {
                let data = JSON.parse(res.data);
                console.log(data, 5555);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave(row, done) { },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
            // console.log(val);
            // this.tableRow = val;
            // this.$notify({
            //     showClose: true,
            //     message: JSON.stringify(val),
            //     type: 'success',
            // });
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(dicName, label) { },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) { },
        pass(id) {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    pass(id).then((res) => {
                        this.handleList();
                    });
                })
                .catch(() => { });
        },
        refuse(id) {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {};
                    data.id = id;
                    data.returnReason = value;
                    refused(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },

        refunded(id) {
            this.$prompt("请输入退回原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {};
                    data.id = id;
                    data.returnReason = value;
                    console.log(data, 1111111);
                    refund(data).then((response) => {
                        console.log(data, 2222222);
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },
        // 查看详情toView
        toView(id) {
            let obj = {
                value: "/work/waterProject/engineer/engineerDetails",
                label: "服务清单详情",
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: { GoodsId: id }
            });
        },
        evaluateInfoView(id) {
            let obj = {
                value: "/work/waterProject/engineer/evaluateInfo",
                label: "评价详情",
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: { GoodsId: id }
            });
        },
        immediatePayment(id, done) {
            serveOrderPay(id).then((response) => {
                this.tableLoading = false;
                if (response.code == "200") {
                    let data = response.data;
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                        console.log(res);
                        if (res.code == "200") {
                            if (res.data == "SUCCESS") {
                                let _this = this;
                                setTimeout(() => {
                                    this.dialogBalancePay = false;
                                    _this.dialogBalancePay = false;
                                    _this.QRCodeDialog = false;
                                    _this.$message({
                                        showClose: true,
                                        message: "支付成功",
                                        type: "success",
                                    });
                                    this.handleList();
                                    _this.handleList();
                                }, 2000);
                            } else {
                                this.QRCodeDialog = false;
                                this.$message({
                                    showClose: true,
                                    message: "支付超时",
                                    type: "error",
                                });
                            }
                            //this.handleList();
                        } else {
                            this.dialogBalancePay = false;
                            this.QRCodeDialog = false;
                            this.$message({
                                showClose: true,
                                message: "支付超时",
                                type: "error",
                            });
                            this.handleList();
                        }
                    });
                    let start = new Date().getTime();
                    while (true) if (new Date().getTime() - start > 1) break;
                    this.config.value = "";
                    this.config.value = data.codeUrl;
                    this.QRCodeDialog = true;
                    // this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error",
                    });
                    done();
                    return;
                }
            });
        },
        downloadExcel() {
            let params = this.downloadData;
            downloadExcelPureWaterGoods(params).then((response) => {
                // 提取文件名
                const filename = response.headers["content-disposition"].match(
                    /filename=(.*)/
                )[1];
                // 将二进制流转为blob
                const blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename));
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob);
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", decodeURI(filename));
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL);
                    this.searchChange(params);
                }
            });
        },
        downloadReplacementReminderExcel() {
            this.downloadReplacementReminderExcelDialog = true;
        },
        downloadReplacementReminderExcelSubmit() {
            let day = this.downloadReplacementReminderExcelForm.day;
            downloadReplacementReminderExcel(day).then((response) => {
                // 提取文件名
                const filename = response.headers["content-disposition"].match(
                    /filename=(.*)/
                )[1];
                // 将二进制流转为blob
                const blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename));
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob);
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", decodeURI(filename));
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL);
                    this.downloadReplacementReminderExcelDialog = false;
                    this.searchChange(this.downloadData);
                }
            });
        },
    },
};
</script>

<style lang="scss">
.remittanceButton {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}

.remittance {
    .recharge {
        margin-top: 10px;
    }
}

.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
